import React from 'react';
import { Box, Card, CardContent, CardHeader, Typography, Button, } from '@kareo/design-system';
var ErrorPage = function (_a) {
    var title = _a.title, message = _a.message, _b = _a.refresh, refresh = _b === void 0 ? false : _b;
    return (React.createElement(Box, { display: "flex", justifyContent: "center", alignItems: "center", minHeight: "70vh" },
        React.createElement(Box, { width: "40%", textAlign: "center" },
            React.createElement(Card, null,
                React.createElement(CardHeader, { title: React.createElement(Typography, { variant: "h2", color: "error", component: "div" }, title) }),
                React.createElement(CardContent, { style: { paddingTop: 0 } },
                    React.createElement(Typography, { variant: "body1", component: "div" }, refresh ? (React.createElement("span", null,
                        'Try',
                        React.createElement(Button, { variant: "text", onClick: function () { return window.location.reload(); } }, "refreshing"),
                        'the page, or contact system admin if the problem persists.')) : (message)))))));
};
export default ErrorPage;
